<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon
          class="close-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="list-modal-title">
      {{ title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<div
  class="list-content"
  [ngClass]="{ mobile: platformService.isTouch | async }"
>
  <cdk-virtual-scroll-viewport
    itemSize="64"
    minBufferPx="600"
    maxBufferPx="600"
  >
    <ion-list>
      <ion-item *cdkVirtualFor="let item of listItems">
        <div class="list-item">{{ item }}</div>
      </ion-item>
    </ion-list>
  </cdk-virtual-scroll-viewport>
</div>

<ion-footer class="footer">
  <div class="buttons-group">
    <ion-button
      (click)="closeModal()"
      class="usf-fill-green-button close-button"
      data-cy="cta-close-button"
    >
      {{ 'i18n.common.close' | translate }}
    </ion-button>
  </div>
</ion-footer>
